module.exports = __webpack_public_path__ + "img/logo-axroad.83353a34.svg";